
export const currencySymbols = {
  AED: "AED",
  USD: "$",
  EUR: "€",
  GBP: "£",
  INR: "₹",
  PKR: "PKR",
  JPY: "¥"
};

export const currencyOptions = [
  { code: 'AED', name: 'UAE Dirham', symbol: 'AED' },
  { code: 'USD', name: 'US Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound', symbol: '£' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'PKR', name: 'Pakistani Rupee', symbol: 'PKR' },
  { code: 'JPY', name: 'Japanese Yen', symbol: '¥' }
];

export function formatCurrency(amount, code = 'AED') {
  const symbol = currencySymbols[code] || code;
  const numAmount = parseFloat(amount) || 0;
  
  // For JPY, don't show decimals as it doesn't use cents
  if (code === 'JPY') {
    return `${symbol} ${Math.round(numAmount)}`;
  }
  
  return `${symbol} ${numAmount.toFixed(2)}`;
}
